import API from "@/lib/httpModule";

/**
 * Create air freight request public
 * @returns
 */
export async function createAirFreightRequestPublic(payload) {
	return API.post_origin(`/air-freight`, payload)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Create air freight request
 * @returns
 */
export async function createAirFreightRequest(payload) {
	return API.post(`/air-freight`, payload)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get air freight requests
 * @returns
 */
export async function getAirFreightRequests(query) {
	return API.get(`/air-freight`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get air freight request by id
 * @param {String} slug
 * @returns
 */
export async function getAirFreightRequestDetail(slug) {
	return API.get(`/air-freight/${slug}`)
		.then(async (res) => {
			const response = res.data;
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}
